module.exports = __webpack_public_path__ + "img/performance.a4e7664e.png";